/**
 * @flow
 * @relayHash e8e2a74887b1b87f5a8899f1acb85980
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PackageTrackerDeliveryConfirmationByRecipientWithoutAuthMutationInput = {|
  pdcbrUuid: string,
  wasDelivered: boolean,
  clientMutationId?: ?string,
|};
export type confirmDeliveryWithoutAuthMutationVariables = {|
  input: PackageTrackerDeliveryConfirmationByRecipientWithoutAuthMutationInput
|};
export type confirmDeliveryWithoutAuthMutationResponse = {|
  +packageTrackerDeliveryConfirmationByRecipientWithoutAuth: ?{|
    +success: ?boolean
  |}
|};
export type confirmDeliveryWithoutAuthMutation = {|
  variables: confirmDeliveryWithoutAuthMutationVariables,
  response: confirmDeliveryWithoutAuthMutationResponse,
|};
*/

/*
mutation confirmDeliveryWithoutAuthMutation(
  $input: PackageTrackerDeliveryConfirmationByRecipientWithoutAuthMutationInput!
) {
  packageTrackerDeliveryConfirmationByRecipientWithoutAuth(input: $input) {
    success
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type:
          'PackageTrackerDeliveryConfirmationByRecipientWithoutAuthMutationInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTrackerDeliveryConfirmationByRecipientWithoutAuth',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType:
          'PackageTrackerDeliveryConfirmationByRecipientWithoutAuthMutation',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'success',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'confirmDeliveryWithoutAuthMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'confirmDeliveryWithoutAuthMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'confirmDeliveryWithoutAuthMutation',
      id: null,
      text:
        'mutation confirmDeliveryWithoutAuthMutation(\n  $input: PackageTrackerDeliveryConfirmationByRecipientWithoutAuthMutationInput!\n) {\n  packageTrackerDeliveryConfirmationByRecipientWithoutAuth(input: $input) {\n    success\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'b57a7b1769ad5324c6c79d32889bc41d';
module.exports = node;
